import { locations } from "@/types/location";
export default {
    currentLocation(state) {
        return locations[state.locationId];
    }
};
